import { useQuery } from "@tanstack/react-query";
import { HttpNOTES } from "../api/httpNOTES";

export const useNOTESGrafico = (idOperacion: number) => {
  return useQuery({
    queryKey: ['notes-grafico', idOperacion],
    queryFn: () => HttpNOTES.getGraficoSubyacentes(idOperacion),
    enabled: !!idOperacion,
    staleTime: 1000 * 60 * 30,
    
    retry: (failureCount, error: any) => {
      // si vino un blob con este tipo es que fue un 404
      if (error instanceof Blob && error.type === "application/problem+json") {
        return false;
      }
      return failureCount < 3; 
    },
  });
};